import type { Lists } from '@ts-lists/interfaces'

import { useListsStore } from '@stores/lists'

import { useAdminRoutes } from '@composables/routes/admin-route.hook'

interface ListsApiOptions {
  onError?: (err: unknown) => void
}

export const useListsApi = async (options?: ListsApiOptions): Promise<Lists | null> => {
  const { $axios } = useNuxtApp()
  const url = useAdminRoutes('admin.config.lists')

  const listsStore = useListsStore()

  try {
    const { data } = await $axios.get(url!)

    const lists = data.data || null
    listsStore.setLists(lists)
    return lists
  } catch (err: unknown) {
    options?.onError?.(err)
    return null
  }
}
